import { Chip, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AxiosConfig from '../../../../config/AxiosConfig';
import b64toBlob from '../../../helpers/utils/blob';

const DownloadableAttachment = ({ attachment }) => {
  const [shortName, setShortName] = useState('');

  useEffect(() => {
    if (attachment?.name?.length > 50) {
      const nameList = attachment?.name.split('.');
      for (const idx in nameList) {
        if (nameList[idx]?.length > 50) {
          nameList[idx] = nameList[idx].substring(0, 50) + '...';
        }
      }
      setShortName(nameList.join('.'));
    } else if (attachment?.name) {
      setShortName(attachment?.name);
    } else if (attachment?.cid) {
      setShortName(attachment?.cid);
    } else {
      setShortName(attachment?._id);
    }
  }, [attachment]);

  const onDownload = () => {
    AxiosConfig.create('get', `/attachments/${attachment?._id}/getContent`)
      .call()
      .exit((res) => {
        const content = res.data;
        if (content && content?.length > 0) {
          const link = document.createElement('a');
          const blobContent = b64toBlob(
            content?.split(',')[1]?.replace(/_/g, '/')?.replace(/-/g, '+'),
            attachment?.mimeType
          );
          const blobUrl = URL.createObjectURL(blobContent);
          link.setAttribute('download', attachment.name);
          link.href = `${blobUrl}`;
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch((err) => console.error(err));
  };

  return (
    <>
      <Tooltip
        title={
          attachment?.link?.length > 0
            ? `Cliquer pour télécharger : ${attachment.name}`
            : "Le client essaie d'envoyer une PJ trop lourde pour être gérée dans Pandora.\nPouvez-vous lui demander de passer par WeTransfer ?"
        }
      >
        <Chip
          label={shortName}
          onClick={onDownload}
          color={'info'}
          size="small"
        />
      </Tooltip>
    </>
  );
};

export default DownloadableAttachment;
